import React, { useState, useEffect } from 'react';
import { DatePicker } from '@material-ui/pickers';
import './style.scss';

const defaultInputStyle = {
  backgroundColor: 'white',
  boxSizing: 'border-box',
  height: 40,
  fontSize: 16,
  paddingRight: '2px !important',
  width: '100%',
};

export function EeDatePicker(props: any) {
  const {
    register,
    inputStyle = defaultInputStyle,
    disabled,
    name,
    defaultValue,
    onChange,
  } = props;

  const [dateState, setDateState] = useState(defaultValue);

  useEffect(() => {
    if (props.value && dateState !== props.value) {
      setDateState(props.value);
    }
  }, [props.value]);

  return props.register ? (
    <DatePicker
      InputProps={{
        style: inputStyle,
      }}
      inputVariant="outlined"
      inputRef={register}
      showTodayButton
      autoOk
      name={name}
      disabled={disabled}
      value={dateState}
      onChange={(date) => {
        setDateState(date?.format('yyyy-MM-DD'));
        onChange && onChange(date);
      }}
      format="yyyy-MM-DD"
      views={['year', 'month', 'date']}
    />
  ) : (
    <DatePicker
      InputProps={{
        style: inputStyle,
      }}
      inputVariant="outlined"
      showTodayButton
      autoOk
      disabled={disabled}
      name={name}
      value={dateState}
      onChange={(date) => {
        const formattedDate = date?.format('yyyy-MM-DD');
        setDateState(formattedDate);
        onChange && onChange(formattedDate);
      }}
      format="yyyy-MM-DD"
      views={['year', 'month', 'date']}
    />
  );
}
